import { render, staticRenderFns } from "./AnswerTimeStatsComponent.vue?vue&type=template&id=5aee6b68"
import script from "./AnswerTimeStatsComponent.vue?vue&type=script&lang=js"
export * from "./AnswerTimeStatsComponent.vue?vue&type=script&lang=js"
import style0 from "./AnswerTimeStatsComponent.vue?vue&type=style&index=0&id=5aee6b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports